import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'amfam-wrap-article',
  templateUrl: './wrap-article.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class WrapArticleComponent {
  @Input() headerContentRef: string;
  @Input() content: string;
  @Input() contentIconPath: string;
}
